<template>
<Button :icon="icon" :disabled ="disabled" @click="doAction"><slot></slot></Button>
</template>
<script>
import { mapMutations } from 'vuex'
  export default {
    name: 'abActionBtn',
    props: {
      'dataKey':{require:false}, //提交的数据的对象的多重key
      'url':{required: true}, // 提交数据请求的url
      'data':{required: true}, // 提交的数据
      "method":{default:"postForm"}, // 提交方式 默认post 可以改为 postForm
      "confimMsg":{required: false},//询问内容
      "successMsg":{required: false},//成功提示内容
      "disabled":{required: false},//是否只读
      "icon":{required: false}, // icon
      "validData":{required: false}, // 触发条件
      "inValidDataMsg":{required: false}, // 触发条件失败时提醒
      "postKey":{required: false}, // 如果设置则逗号分隔单个字段提交到后台
      "afterFn":{type: Function}// 后置动作
    },
    data() {
      return {

      }
    },
    methods: {
   	  doAction(){

   		 if(this.confimMsg){
   			this.$Modal.confirm({
                title: '请注意',
                content: this.confimMsg,
                onOk: () => {
                this.postAction();
                }
            });
   		 }else{
   			this.postAction();
   		 }
   	  },

   	postAction() {
  		if(!this.data){
			console.info("ab-action-btn :data 为空，未执行提交动作");
  			return;
  		}
   		let data = this.data;

      // 检查数据是否正常
      if(this.validData){
        for(var i = 0 ; i < data.length ; i++){
          var item = data[i];
          var valid = eval('(item.'+this.validData+')');
          if(!valid){
            this.$Message.error(this.inValidDataMsg || "选择的数据不符合条件!");
            return;
          }
        }
      }

   		if(this.postKey && Array.isArray(data)){
         let arrayKeys = ""
         arrayKeys = this.data.map(item => item[this.postKey]);
         let deepKeys = [];
         if(this.dataKey){
       
          arrayKeys = this.data.map(item => item[this.dataKey]);
          
          if(this.dataKey.indexOf(":")>-1){
            deepKeys =  this.dataKey.split(":");
            arrayKeys = this.data.map(item => item[deepKeys[0]][deepKeys[1]]);
          }
           
           
         }
   			
   			data = {};
   			data[this.postKey] = arrayKeys.join(',');
   		}

    	let rtn = this.abHttpUtil[this.method](this.url, data);

        rtn.then((data) =>{
          if(data.isOk) {
        	  this.afterFn();
            this.$Message.success(this.successMsg || data.msg);
          } else {
        	  this.$Message.error(data.msg);
          }
        },(errorCode)=> {
        	this.$Message.error("请求失败!" + errorCode);
        });
      },
    }
  }
</script>
